import { DepositTerminationApplication } from "@/modules/application/components";
import type { IOperationPageProps } from "@/shared/common/types";

export const DepositTerminationApplicationPage = ({ isEdit, isCopy }: IOperationPageProps) => (
  <DepositTerminationApplication isEdit={isEdit} isCopy={isCopy}/>
);
